import React from 'react';
import CustomButton from '../../CustomButton'
import './ComoComecarSection.css'

export function ComoComecarSection() {
    return (
        <section className="steps-section-client">
            <div className="section-container-client">
                <h2 className="section-title-client">Como começar em 3 passos</h2>

                <div className="steps-grid-client">
                    <div className="steps-list-client">
                        <div className="step-item-client">
                            <div className="step-number-client">1</div>
                            <div>
                                <h3 className="step-title-client">Baixe o app</h3>
                                <p className="step-text-client">
                                    Disponivel para iOS e Android. Crie sua conta em menos de 1 minuto.
                                </p>
                            </div>
                        </div>

                        <div className="step-item-client">
                            <div className="step-number-client">2</div>
                            <div>
                                <h3 className="step-title-client">Encontre parceiros</h3>
                                <p className="step-text-client">
                                    Busque por localizacao, servicos e avaliacoes. Escolha o melhor para seu pet.
                                </p>
                            </div>
                        </div>

                        <div className="step-item-client">
                            <div className="step-number-client">3</div>
                            <div>
                                <h3 className="step-title-client">Agende e aproveite</h3>
                                <p className="step-text-client">
                                    Escolha data e horario, leve seu pet e relaxe. Tudo cuidado com carinho.
                                </p>
                            </div>
                        </div>

                        <div className="steps-button-wrapper-client">
                            <CustomButton
                                variant="contained"
                                sx={{
                                    backgroundColor: '#FF914D',
                                    color: '#FFFFFF',
                                    padding: '12px 24px',
                                    fontSize: '15px',
                                    '&:hover': {
                                        backgroundColor: '#e67e3d',
                                    },
                                }}
                            >
                                <span className="material-icon">download</span>
                                Baixar para iOS
                            </CustomButton>

                            <CustomButton
                                variant="contained"
                                sx={{
                                    fontSize: '15px',
                                    padding: '12px 24px',
                                }}
                            >
                                <span className="material-icon">download</span>
                                Baixar para Android
                            </CustomButton>
                        </div>
                    </div>

                    <div className="steps-image-wrapper-client">
                        <img
                            src="/images/celular.png"
                            alt="Pessoa usando o app Clube do Banho no celular"
                            style={{ objectFit: "cover", width: '100%', height: '100%' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}